import { Group } from "@/types/group";
import { Image, ImageStyle } from "expo-image";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { StyleProp } from "react-native";
import { getGroupPictureThumbnail } from "@/utils/getGroupPictureThumbnail";
import { useGroupImageOverride } from "@/utils/groupImageOverrides";

const DefaultGroupImage = require("@/assets/images/default-group.webp");

type Props = {
  groupId: string;
  photoUpdatedAt?: Group["photoUpdatedAt"];
  fallbackOverride?: string;
  size?: number;
  style?: StyleProp<ImageStyle>;
};

const GroupAvatarInner: React.FC<Props> = ({
  groupId,
  photoUpdatedAt,
  fallbackOverride,
  size = 40,
  style,
}) => {
  const { t } = useTranslation();
  const override = useGroupImageOverride(groupId);
  const uri =
    override ??
    fallbackOverride ??
    getGroupPictureThumbnail(groupId, photoUpdatedAt?.toMillis?.());

  return (
    <Image
      source={{ uri }}
      style={[
        { width: size, height: size, borderRadius: size / 2 },
        style,
      ]}
      placeholder={DefaultGroupImage}
      cachePolicy="disk"
      transition={300}
      accessibilityLabel={t("GROUP_AVATAR_ALT")}
    />
  );
};

export const GroupAvatar = memo(GroupAvatarInner, (prev, next) => {
  return (
    prev.groupId === next.groupId &&
    prev.photoUpdatedAt === next.photoUpdatedAt &&
    prev.fallbackOverride === next.fallbackOverride &&
    prev.size === next.size &&
    prev.style === next.style
  );
});
